// extracted by mini-css-extract-plugin
export default {"consent":"CookieModal_consent__zv+mt","consentGrid":"CookieModal_consentGrid__SpJIP","buttonGrid":"CookieModal_buttonGrid__ecWte","consentModal":"CookieModal_consentModal__MCk6M"};